<div class="parameter-dialog-container wg-quick-create-dialog">
  <div class="side-popup">

    <!-- HEADER: title + close X (skeleton copied from sem-parameter-dialog) -->
    <div class="pop-header">
      <div class="pop-header__left">
        <span class="pop-header__title">{{ tr('WebGalis_QuickCreate_Title', 'Nov vnos') }}</span>
      </div>
      <div class="pop-header__close" (click)="cancel()">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </div>
    </div>

    <!-- BODY: hosted backend form + footer buttons -->
    <div class="popup-inner-content" [class.wg-quick-create-busy]="loading || saving" [attr.aria-busy]="loading || saving">
      @if (loading) {
        <div class="wg-quick-create-loading">{{ tr('WebGalis_Loading', 'Nalaganje ...') }}</div>
      }
      <!-- SAVE OVERLAY: covers the hosted form while POST api/data is in flight
           (saving mirrors the hosted SemDynamicComponent.loading flag) -->
      @if (saving) {
        <div class="wg-quick-create-overlay" role="status" aria-live="polite">
          <div class="loader"></div>
          <span class="wg-quick-create-overlay__text">{{ tr('WebGalis_Saving', 'Shranjevanje ...') }}</span>
        </div>
      }
      @if (error) {
        <p class="wg-quick-create-error">{{ error }}</p>
      }

      <ng-container #vc></ng-container>

      @if (serverError) {
        <p class="wg-quick-create-error">{{ serverError }}</p>
      }

      <div class="btn-group btn-group-param-popup">
        <button type="button" class="accept" [disabled]="loading || saving || error" (click)="save()">{{ tr('WebGalis_Save', 'Shrani') }}</button>
        <button type="button" class="decline" [disabled]="saving" (click)="cancel()">{{ tr('WebGalis_Cancel', 'Prekliči') }}</button>
      </div>
    </div>

  </div>
</div>
